import { Td, Tr } from '@chakra-ui/react'
import { ReactNode } from 'react'

export interface ITableEmptyRowProps {
  /** Número de colunas da tabela — o mesmo `colSpan` que a linha ocupava à mão. */
  colSpan: number
  /** Substantivo do tipo de registro, minúsculo e no singular: `cupom`, `vaga`, `chamado`. */
  entity?: string
  /** Concordância pt-BR: ligue para substantivo feminino (`Nenhuma vaga encontrada`). */
  feminine?: boolean
  /** Substitui a frase montada, para o vazio que não é "nenhum registro": `Nenhuma comissão no período`. */
  message?: ReactNode
}

/**
 * Linha de estado vazio das tabelas do painel.
 *
 * A frase é montada a partir de `entity` — a página declara o tipo de registro, não a cópia.
 * Havia ~40 frases distintas para isso, alternando `encontrado` / `cadastrado` / `disponível`,
 * com e sem ponto final, e duas grafias diferentes na mesma página. A grafia agora é uma só:
 * **`Nenhum <entity> encontrado`**, sem ponto.
 *
 * O padding generoso mora aqui e não nas páginas. É a exceção que o `theme.ts` já reconhece:
 * a linha de vazio é um bloco de mensagem, não uma linha de dados, e por isso não segue o
 * ritmo de 49px das demais.
 */
export default function TableEmptyRow({ colSpan, entity, feminine = false, message }: ITableEmptyRowProps) {
  const text =
    message ?? `${feminine ? 'Nenhuma' : 'Nenhum'} ${entity ?? 'registro'} ${feminine ? 'encontrada' : 'encontrado'}`

  return (
    <Tr>
      <Td colSpan={colSpan} textAlign="center" color="gray.500" py={10}>
        {text}
      </Td>
    </Tr>
  )
}
